// Module
var code = " <div> <span>{{ctrl.periodText()}}</span> </div> ";
// Exports
module.exports = code;